import React__default from 'react';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var annotatedComponents = new WeakMap();

function withUniqueId(OriginalComponent) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    prefix: null
  };
  var prefix = config.prefix;

  if (!annotatedComponents.has(OriginalComponent)) {
    prefix = prefix || OriginalComponent.displayName || OriginalComponent.name;

    var WithUniqueId = /*#__PURE__*/function (_React$PureComponent) {
      _inherits(WithUniqueId, _React$PureComponent);

      var _super = _createSuper(WithUniqueId);

      function WithUniqueId(props) {
        var _this;

        _classCallCheck(this, WithUniqueId);

        _this = _super.call(this, props);

        _defineProperty(_assertThisInitialized(_this), "uniqueId", null);

        _this.uniqueId = WithUniqueId.uniqueId;
        WithUniqueId.uniqueId += 1;
        return _this;
      }

      _createClass(WithUniqueId, [{
        key: "render",
        value: function render() {
          return /*#__PURE__*/React__default.createElement(OriginalComponent, _extends({}, this.props, {
            uniqueId: "".concat(prefix, "-").concat(this.uniqueId)
          }));
        }
      }]);

      return WithUniqueId;
    }(React__default.PureComponent);

    _defineProperty(WithUniqueId, "displayName", "WithUniqueId(".concat(prefix, ")"));

    _defineProperty(WithUniqueId, "defaultProps", OriginalComponent.defaultProps);

    _defineProperty(WithUniqueId, "propTypes", OriginalComponent.propTypes);

    _defineProperty(WithUniqueId, "uniqueId", 0);

    annotatedComponents.set(OriginalComponent, WithUniqueId);
    return WithUniqueId;
  }

  return annotatedComponents.get(OriginalComponent);
}

export { withUniqueId };
